var promotion_slider = 0;
function initPromotionSlider() {
  if (promotion_slider == 0) {
    promotion_slider = 1;
    jQuery(".promotion-products").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
      arrows: true,
      variableWidth: false
    }
    );
  } else {
    jQuery(".promotion-products").slick('refresh');
  }
}

function formatPriceWithSup(price) {
  const formatted = slate.Currency.formatMoney(price, window.theme.moneyFormat).replace(/<\/?[^>]+(>|$)/g, "");
  const symbol = window.theme.currentCurrencySymbol;
  if (formatted.includes(symbol)) {
    return formatted.replace(symbol, `<em class="currency-symbol">${symbol}</em>`);
  }
  return `<em class="currency-symbol">${symbol}</em>${slate.Currency.removeCurrencySymbol(formatted)}`;
}

function resetButtonHtml() {
  $('.promotion-form').each(function () {
    var this_form = $(this);
    var buttonHtml = this_form.find('.promotion_add');
    if (buttonHtml.hasClass('added')) {
      buttonHtml.removeClass('added');
    }
    buttonHtml.children('.added-image').css('display', 'none');
  });
}
function openCartPopup() {
  window.theme.lastActiveElement = document.activeElement;
  const cartPopup = document.getElementById("cart-popup");
  cartPopup.style.display = "block";
  cartPopup.classList.add("active");
  cartPopup.setAttribute('aria-hidden', 'false');
  cartPopup.focus();
  document.getElementById("cart-popup-overlay").style.display = "block";
  jQuery('body').addClass("stopScrolling");
  initPromotionSlider();
  setTimeout(function () {
    this.toggleProductDetailOverlay(true);
  }, 1000);
}
function closePopup() {
  try { jQuery(".promotion-products").slick('slickGoTo', 0); } catch (error) { }
  this.resetButtonHtml();
  jQuery('.product-card__variant-container[data-show-added-btn]').data('show-added-btn', false);
  jQuery('.promotion-upsells-items .add-product-variant').css('display', 'block');
  jQuery('.promotion-upsells-items .promotion_added_variant_btn').css('display', 'none');
  const cartPopup = document.getElementById("cart-popup");
  cartPopup.style.display = "none";
  cartPopup.classList.remove("active");
  cartPopup.setAttribute('aria-hidden', 'true');
  document.getElementById("cart-popup-overlay").style.display = "none";
  if (window.theme.lastActiveElement) {
    window.theme.lastActiveElement.focus();
    window.theme.lastActiveElement = null;
  }
  jQuery('body').removeClass("stopScrolling");
}
function toggleProductDetailOverlay(show) {
  const loaderOverlay = document.querySelector('.add-bag-overlay__loader');
  if (show && loaderOverlay) {
    loaderOverlay.classList.add('hide-overlay');
    loaderOverlay.classList.add('fade-overlay');
  } else if (loaderOverlay) {
    loaderOverlay.classList.remove('hide-overlay');
    loaderOverlay.classList.remove('fade-overlay');
  }

}


function updateCartPopup(product) {
  if (document.body.classList.contains('template-cart') || window.location.pathname.indexOf('/cart') === 0 || (window.theme && window.theme.template && window.theme.template.template === 'cart')) {
    if (window.theme && window.theme.cartPage) {
      if (typeof window.theme.cartPage.updateCartItemsEvent === 'function') {
        window.theme.cartPage.updateCartItemsEvent();
      }
      if (typeof window.theme.cartPage.refreshCart === 'function') {
        window.theme.cartPage.refreshCart();
      }
    }
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 500);
    return;
  }

  // The added-to-bag popup belongs to the 'popup' cart type. Under 'drawer-v3'
  // (settings.cart_type, stamped on window.theme.cartType in theme.liquid) My
  // Bag is the <theme-cart-drawer> dialog, so the popup never opens there.
  // Gated here, at the one entry every add path reaches (product-card.js,
  // tagalys-script-footer.liquid, product.js and the two XGen scripts), so the
  // callers stay as they are and the /cart?view=json read and the XGen
  // recommendation call below are skipped as well. Sits AFTER the cart-page
  // branch on purpose: under drawer-v3 the cart page still runs in popup mode
  // (main-cart.liquid aliases it), so an add made there keeps its
  // refresh-and-scroll feedback. Every other cart_type is untouched.
  //
  // Instead, tell the drawer the cart changed behind its store: it re-reads
  // the cart now, while the shopper is still on the page, so the new line
  // (and its Weglot translation) is ready before the bag is opened rather
  // than fetched on the open itself (cart-drawer.js handleExternalAdd).
  if (window.theme && window.theme.cartType === 'drawer-v3') {
    document.dispatchEvent(new CustomEvent('cart:added-elsewhere', { detail: { product } }));
    return;
  }

  fetch('/cart?view=json')
    .then(response => response.json())
    .then(cart => {
      const cartProduct = cart.items.find((item) => item.variant_id === product.vId || item.id === product.vId || item.variant_id + "" === product.vId || item.id + "" === product.vId) || {};
      const finalPrice = cartProduct.final_price || product.final_price || cartProduct.price || product.price;
      const comparePrice = cartProduct.compare_at_price || cartProduct.original_price || product.compare_price || product.original_price;
      const imageSrc = cartProduct.image?.src || product.image?.src || cartProduct.image || product.image;
      if (window.theme.upsells.type === 'xgen') getXgenAtcRec(cartProduct.id);

      let original_price = '';
      let discount_percent = '';
      if (comparePrice > finalPrice) {
        original_price = `<span class="original-price">${formatPriceWithSup(comparePrice)}</span>`;
        discount_percent = `<span class="discount-percent">(-${Math.round(((comparePrice - finalPrice) * 100) / comparePrice)}%)</span>`;
      }
      this.toggleProductDetailOverlay(false);
      var size = '';
      if (cartProduct.size || product.size) {
        size = `<div class='size'>${window.theme && window.theme.strings && window.theme.strings.sizeLabel || 'Size:'} ${cartProduct.size || product.size}</div>`;
      }
      const productDetails = `
        <div class="product-image">
          <img src="${imageSrc}" alt="${product.title}" />
        </div>
        <div class="product-info">
          <div class="product-title">
            ${product.title}
          </div>
          <div class="details">
            ${size}
            <div class="qty">
              ${window.theme && window.theme.strings && window.theme.strings.qtyLabel || 'Qty:'} ${product.quantity}
            </div>
            <div class="price-block">
              ${original_price}
              <div class="discount-line">
                <span class="${original_price ? 'new-price' : 'price'}">
                  ${formatPriceWithSup(finalPrice)}
                </span>
                ${discount_percent}
              </div>
            </div>
          </div>
        </div>
      `;
      if( document.getElementById("popup-product-details") ) document.getElementById("popup-product-details").innerHTML = productDetails;
      openCartPopup();
      this.toggleProductDetailOverlay(true);
    });
}


jQuery(document).ready(function () {
  jQuery(".cart-popup-overlay").click(function () {
    closePopup();
  });
  jQuery(document).on('keydown:escape', function (e) {
    closePopup();
  });
  jQuery(document).on('click', '.promotion .promotion_add_option', function () {
    // show the variants if there are multiple variants
    var button = jQuery(this);
    var form = button.closest('.promotion-form');
    var variants = form.find('.product-card__variants');
    if (variants.length && variants.children().length) {
      variants.addClass("product-card__variants--show");
      return false;
    } else {
      return false;
    }
  });
  jQuery(document).on('click', '.promotion .promotion_add', function () {
    // add product from upsell list 
    var add_product = $(this);
    const productId = add_product.data('upsell-product-id');
    const productFeatureImage = add_product.data('upsell-product-feature-image');
    const productUrl = add_product.data('upsell-product-url');
    const productVendor = add_product.data('upsell-product-vendor');
    const productPrice = add_product.data('upsell-product-price');
    const productComparePrice = add_product.data('upsell-product-compare-price');

    const itemObj = {
      id: productId,
      quantity: 1,
      image: productFeatureImage,
      url: productUrl,
      vendor: productVendor,
      price: productPrice,
      compare_price: productComparePrice
    };
    theme.sideCart.addItemFrmMybag(itemObj);


    const addedImage = add_product.children('.added-image');
    add_product.addClass("added");
    addedImage.css('display', 'block');

  });

  jQuery(document).on('click', '.promotion-upsells-items .add-product-variant', function () {
    // add product from variant
    var variant_id = jQuery(this).data('variant-id');
    var featured_image = jQuery(this).data('variant-feature-image');
    var url = jQuery(this).closest('.promotion-form').find('.url').val();
    var vendor = jQuery(this).closest('.promotion-form').find('.vendor').val();
    var price = jQuery(this).closest('.promotion-form').val();
    var compare_price = $(this).closest('.promotion-form').find('.product-card__variants')
    var itemObj = {
      id: variant_id,
      quantity: 1,
      image: featured_image,
      url: url,
      vendor: vendor,
      price: price,
      compare_price: compare_price
    };
    theme.sideCart.addItemFrmMybag(itemObj);
    const container = jQuery(this).closest('.product-card__variant-container');

    // Set the data attribute to "true"
    jQuery(this).css('display', 'none');
    container.find('.promotion_added_variant_btn').css('display', 'flex');
    return false;
  });
});


function getXgenAtcRec(pid) {
  window.xgenCommon.recommend({
    ids: [window.xgen_vars.xgen_upsells_id]
  }).then((data) => {
    const cart = window.theme.sideCart.cart || { items: [] };
    const result = data[window.xgen_vars.xgen_upsells_id]
    const xgenProducts = result.items
    if (xgenProducts.length) {
      const upsellProducts = xgenProducts.map((item) => window.xgenCommon.unifyProduct(item))
      const availableProducts = upsellProducts.filter(product => product.variants.some(variant => variant.available));
      const productsNotInCart = availableProducts.filter(product => cart.items.every(cartItem => cartItem.product_id !== product.id));
      const promotionProducts = document.querySelector('.promotion-products');
      jQuery(".promotion-products").slick('destroy');
      promotionProducts.innerHTML = '';

      if (promotionProducts && productsNotInCart.length) {
        const promotionUpsellContainer = document.querySelector('.promotion-upsells-items');
        promotionUpsellContainer.classList.remove('hidden');
        promotion_slider = 0;
        let recommendationsHtml = ""
        productsNotInCart.forEach(product => {
          const isOnlyInStore = product.tags && product.tags.some(tag => typeof tag === 'string' && tag.trim().toLowerCase() === 'in-store');
          recommendationsHtml += `
          <div class="promotion" data-sku="${product.variants[0].sku}">
              <a href="${product.url}">
                <img src="${product.featured_image}" alt="${product.title}" width="68" height="86">
            </a>
            <div class="title">${product.title}</div>
            <div class="price">${formatPriceWithSup(product.price)}</div>
            <div class="promotion-form ${isOnlyInStore ? 'hide' : ''}">
              ${product.variants.size > 1 ? `
                <button  class="promotion_add_option" aria-label="Add to bag option" >
                  <svg class="added-image" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <g clip-path="url(#clip0_3339_6012)">
                    <circle cx="7.11279" cy="7" r="6.125" fill="white"/>
                    <path d="M5.99447 9.74507L3.29461 7.04521L4.19457 6.14526L5.99447 7.94516L9.59429 4.34535L10.4942 5.2453L5.99447 9.74507Z" fill="#333333"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.112793 7C0.112793 3.13401 3.2468 0 7.11279 0C10.9788 0 14.1128 3.13401 14.1128 7C14.1128 10.866 10.9788 14 7.11279 14C3.2468 14 0.112793 10.866 0.112793 7ZM7.11279 12.7273C3.94971 12.7273 1.38552 10.1631 1.38552 7C1.38552 3.83691 3.94971 1.27273 7.11279 1.27273C10.2759 1.27273 12.8401 3.83691 12.8401 7C12.8401 10.1631 10.2759 12.7273 7.11279 12.7273Z" fill="#333333"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_3339_6012">
                    <rect width="13.7745" height="14" fill="white" transform="translate(0.112793)"/>
                    </clipPath>
                    </defs>
                  </svg>
                  Add
                </button>
                <div class="product-overlay"></div>
                <div role="list" class="product-card__variants">
                  <div role="listitem" class="product-card__variant-container hide">
                    <button class="promotion_added_variant btn btn--text" aria-label="Add to bag">
                      <svg class="added-image-variant"  xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <g clip-path="url(#clip0_3339_6012)">
                        <circle cx="7.11279" cy="7" r="6.125" fill="white"/>
                        <path d="M5.99447 9.74507L3.29461 7.04521L4.19457 6.14526L5.99447 7.94516L9.59429 4.34535L10.4942 5.2453L5.99447 9.74507Z" fill="#333333"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.112793 7C0.112793 3.13401 3.2468 0 7.11279 0C10.9788 0 14.1128 3.13401 14.1128 7C14.1128 10.866 10.9788 14 7.11279 14C3.2468 14 0.112793 10.866 0.112793 7ZM7.11279 12.7273C3.94971 12.7273 1.38552 10.1631 1.38552 7C1.38552 3.83691 3.94971 1.27273 7.11279 1.27273C10.2759 1.27273 12.8401 3.83691 12.8401 7C12.8401 10.1631 10.2759 12.7273 7.11279 12.7273Z" fill="#333333"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_3339_6012">
                        <rect width="13.7745" height="14" fill="white" transform="translate(0.112793)"/>
                        </clipPath>
                        </defs>
                      </svg>
                      Add
                    </button>
                  </div>
                  ${product.variants.map(variant => `
                    <div role="listitem" class="product-card__variant-container" data-show-added-btn="false" >
                      ${variant.available ? `
                        <button class="promotion_added_variant_btn btn btn--text" style="display: none;" aria-label="{{ 'cart.general.add_to_bag' | t }}">
                          <svg class="added-image-variant"  xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <g clip-path="url(#clip0_3339_6012)">
                            <circle cx="7.11279" cy="7" r="6.125" fill="white"/>
                            <path d="M5.99447 9.74507L3.29461 7.04521L4.19457 6.14526L5.99447 7.94516L9.59429 4.34535L10.4942 5.2453L5.99447 9.74507Z" fill="#333333"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.112793 7C0.112793 3.13401 3.2468 0 7.11279 0C10.9788 0 14.1128 3.13401 14.1128 7C14.1128 10.866 10.9788 14 7.11279 14C3.2468 14 0.112793 10.866 0.112793 7ZM7.11279 12.7273C3.94971 12.7273 1.38552 10.1631 1.38552 7C1.38552 3.83691 3.94971 1.27273 7.11279 1.27273C10.2759 1.27273 12.8401 3.83691 12.8401 7C12.8401 10.1631 10.2759 12.7273 7.11279 12.7273Z" fill="#333333"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_3339_6012">
                            <rect width="13.7745" height="14" fill="white" transform="translate(0.112793)"/>
                            </clipPath>
                            </defs>
                          </svg>
                          Add
                        </button>
                        <button class="add-product-variant btn btn--text " data-variant-id="${variant.id}"  data-variant-feature-image="${product.featured_image}" >
                          ${variant.title}
                        </button>
                      ` : ''}
                    </div>
                  `).join(' ')}
                  <div role="listitem" class="product-card__variant-container">
                    <button type="button" class="close-show-variants" aria-label="Close variants">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M8.36702 4.53952C8.58739 4.33412 8.59953 3.98898 8.39414 3.7686C8.18875 3.54823 7.8436 3.53609 7.62323 3.74148L6.02716 5.22906L4.53958 3.63299C4.33419 3.41262 3.98904 3.40048 3.76866 3.60587C3.54829 3.81126 3.53615 4.15641 3.74154 4.37678L5.22912 5.97285L3.63305 7.46043C3.41268 7.66582 3.40054 8.01097 3.60593 8.23134C3.81132 8.45171 4.15647 8.46386 4.37684 8.25846L5.97291 6.77088L7.46049 8.36695C7.66588 8.58733 8.01103 8.59947 8.2314 8.39408C8.45177 8.18869 8.46392 7.84354 8.25852 7.62317L6.77095 6.0271L8.36702 4.53952Z" fill="#333333"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.10352e-05 6C6.10352e-05 2.68629 2.68635 0 6.00006 0C9.31377 0 12.0001 2.68629 12.0001 6C12.0001 9.31371 9.31377 12 6.00006 12C2.68635 12 6.10352e-05 9.31371 6.10352e-05 6ZM6.00006 10.9091C3.28885 10.9091 1.09097 8.71122 1.09097 6C1.09097 3.28878 3.28885 1.09091 6.00006 1.09091C8.71128 1.09091 10.9092 3.28878 10.9092 6C10.9092 8.71122 8.71128 10.9091 6.00006 10.9091Z" fill="#333333"/>
                      </svg>
                    </button>
                  </div>
                </div>
              ` : `<button  class="promotion_add" aria-label="Add to bag"
                  data-upsell-product-id='${product.variants[0].id}'
                  data-upsell-product-feature-image="${product.featured_image}"
                  data-upsell-product-url="${product.url}"
                  data-upsell-product-vendor="${product.vendor}"
                  data-upsell-product-price="${product.price}"
                  data-upsell-product-compare-price="${product.compare_at_price}"
                  >
                  <svg class="added-image" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <g clip-path="url(#clip0_3339_6012)">
                    <circle cx="7.11279" cy="7" r="6.125" fill="white"/>
                    <path d="M5.99447 9.74507L3.29461 7.04521L4.19457 6.14526L5.99447 7.94516L9.59429 4.34535L10.4942 5.2453L5.99447 9.74507Z" fill="#333333"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.112793 7C0.112793 3.13401 3.2468 0 7.11279 0C10.9788 0 14.1128 3.13401 14.1128 7C14.1128 10.866 10.9788 14 7.11279 14C3.2468 14 0.112793 10.866 0.112793 7ZM7.11279 12.7273C3.94971 12.7273 1.38552 10.1631 1.38552 7C1.38552 3.83691 3.94971 1.27273 7.11279 1.27273C10.2759 1.27273 12.8401 3.83691 12.8401 7C12.8401 10.1631 10.2759 12.7273 7.11279 12.7273Z" fill="#333333"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_3339_6012">
                    <rect width="13.7745" height="14" fill="white" transform="translate(0.112793)"/>
                    </clipPath>
                    </defs>
                  </svg>
                  Add
                </button>`}
              <input type="hidden" class="id" value="${product.variants[0].id}">
              <input type="hidden" class="image" value="${product.featured_image}">
              <input type="hidden" class="vendor" value="${product.vendor}">
              <input type="hidden" class="price" value="${product.price}">
              <input type="hidden" class="url" value="${product.url}">
              <input type="hidden" class="compare_price" value="${product.compare_at_price}">
            </div>
          </div>`
        });
        promotionProducts.innerHTML = recommendationsHtml;
        const wrongCurrencyVariantIds = productsNotInCart.filter(product => { 
          const currency = product.currency ? product.currency.code : product.price_currency
          return currency !== Shopify.currency.active}).map(product => product.variants[0].id);
        if (wrongCurrencyVariantIds.length && typeof window.getProductPrices === 'function') {
          console.log("Fixing cart recommendations currency");
          window.getProductPrices(wrongCurrencyVariantIds)
        }
        initPromotionSlider();
      }


      if (result && result.items && result.items.find((item)=>{ return item.price_currency !== Shopify.currency.active }) && typeof window.getProductPrices === 'function') {
        console.log('XGen results not in currency ' + Shopify.currency.active + '. Fetching product prices.')
        const variantIds = [];
        result.items.forEach(item => {
          const product = window.xgenCommon.unifyProduct(item);
          if (product.variants) {
            product.variants.forEach(v => {
              if (v.id) {
                variantIds.push(v.id.toString().replace('gid://shopify/ProductVariant/', ''));
              }
            });
          }
        });
        if (variantIds.length) {
          window.getProductPrices([...new Set(variantIds)]);
        }
      }
    }
  });
}
class ProductCardSlider extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }
  connectedCallback() {
    this.setupObserver();
  }
  setupObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this._initialized) {
          this.initSlider();
          this._initialized = true;
          obs.unobserve(this);
        }
      });
    }, {
      // Set up (and load the deferred slides) about one card row before the
      // card scrolls into view, so its images are in place before a swipe.
      rootMargin: '300px 0px',
    });
    observer.observe(this);
  }
  async initSlider() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;
    // Slides after the first are rendered with data-src / data-srcset only (see
    // renderHelpers.productCard.images in tagalys-common-script.js): a
    // loaded-more PLP that decoded every slide of every card used enough memory
    // for iOS Safari to reload the page. Load this card's slides now.
    this.querySelectorAll('img[data-srcset]').forEach((img) => {
      img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    });
    new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      roundLengths: true,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
      },
      preloadImages: false,
      lazy: true,
      watchSlidesProgress: true,
      observer: true,
      // Not observeParents: it puts a MutationObserver on every ancestor up to
      // <html>, and Swiper answers each attribute change there with its resize
      // handler (re-measure + re-layout). Every body class/style change (menu
      // open/close, sticky header, popups) then re-laid out every card slider on
      // the page. Swiper's own ResizeObserver already follows real size changes.
      observeParents: false,
    });
  }
}
customElements.define('product-card-slider', ProductCardSlider);